export default "__VITE_ASSET__YeiWtv6Q__"